export const KBB_RESEARCHABLE_API = {
	sort: {
		MOST_RECENT: {
			id: 1, // API sort support: Sort by submission time (desc)
			label: 'Most Recent'
		},
		HIGHEST_RATING: {
			id: 3, // API sort support: Sort by rating (desc), then by submission time (desc)
			label: 'Highest Rating'
		},
		LOWEST_RATING: {
			id: 4, // API sort support: Sort by rating (asc), then by submission time (desc)
			label: 'Lowest Rating'
		}
	},
	filter: {
		ALL_RATINGS: {
			id: null,
			label: 'All Ratings'
		},
		FIVE_STARS: {
			id: 4, // API filter support: Rating equals 5
			label: '5 stars'
		},
		FOUR_STARS: {
			id: 3, // API filter support: Rating equals 4
			label: '4 stars'
		},
		THREE_STARS: {
			id: 2, // API filter support: Rating equals 3
			label: '3 stars'
		},
		TWO_STARS: {
			id: 1, // API filter support: Rating equals 2
			label: '2 stars'
		},
		ONE_STAR: {
			id: 0, // API filter support: Rating equals 1
			label: '1 star only'
		}
	}
};

// Helper functions to get values
export const getSortIdByLabel = (label) => {
	const option = Object.values(KBB_RESEARCHABLE_API.sort).find(opt => opt.label === label);
	return option?.id;
};
export const getFilterIdByLabel = (label) => {
	const option = Object.values(KBB_RESEARCHABLE_API.filter).find(opt => opt.label === label);
	return option?.id;
};